export default __webpack_public_path__ + "static/media/sponsor-icon-active.a55026bb.webp";